import { Navigate } from "react-router-dom";

export default function ProtocolSettingsPage() {
  return <Navigate to="/account/appearance" replace />;
}
